/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invest_Investinfo1Inputs */

const en_invest_investinfo1 = /** @type {(inputs: Invest_Investinfo1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do not invest unless you are prepared to lose all the money you invest. These are high-risk investments and you are unlikely to be protected if something goes wrong.`)
};

/**
* | output |
* | --- |
* | "Do not invest unless you are prepared to lose all the money you invest. These are high-risk investments and you are unlikely to be protected if something goe..." |
*
* @param {Invest_Investinfo1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const invest_investinfo1 = /** @type {((inputs?: Invest_Investinfo1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invest_Investinfo1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_invest_investinfo1(inputs)
});
export { invest_investinfo1 as "invest_investInfo" }